
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function LongListDefaultMessage() 
{
    const { app_user } = useCTAL();
  
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p>Hi {app_user.FirstName},</p>

                    <p><b>Your Long List doesn't have any Actions yet!</b></p>

                    <p>Best Practice is to add new private Actions <u>here</u> in your private Long List using the Text Box labeled 'New Private Action Title' above and then
                       only move them individually to your Short List when you're ready to work on them because ... well you want to keep your Short List short,
                       and it's hard to finish what you're currently working on if you keep getting getting interrupted by new Actions. This Long List will keep
                       your private Actions safely stored until you are ready to prioritize them</p>

                    <p>If you are only using this app to manage your own Action List that's all the instructions you need :)</p>

                    <p>Shared Actions need to be added to a Team List. Either use the User Pane to create your own Team or join an existing Team.
                       You can also ask a Team Admin to send you a Team Invitation using your unique username: <b>{app_user.UserName}</b>.</p>

                    <div class="row mt-1">
                        <div class="col">
                            <a href="#"><img class="list_item_icon" src="./images/info.svg" alt="users" border="0"/></a>
                            <span class="mt-2">Click on the Information icon above for more help.</span>
                        </div>
                    </div>
                    
                    <p></p>

                    <p>Let's get going!</p>
                </small>
            </div>
        </> 
    );
}

/*
Then select the Team from your User List Index and add the new Action at the 
top of the screen and click Create. Then you can either assign a Team Action to yourself (i.e., move it to your Short List) or assign it
to another Team Member using the Action's Dropdown menu.
*/